export const config = {
  '7fs': {
    x: 0,
    y: 0,
    scale: 1,
  },
  '8fs': {
    x: 0,
    y: 0,
    scale: 1,
  },
  '9fs': {
    x: 0,
    y: 0,
    scale: 1,
  },
  '10fs': {
    x: 0,
    y: 0,
    scale: 1,
  },
  'bg_sky_mountain': {
    x: 0,
    y: 0,
    scale: 1,
  },
  'castle': {
    x: 0,
    y: 0,
    scale: 1,
  },
  'bg_sky_mountains': {
    x: 0,
    y: 0,
    scale: 1,
  },
  'grass_stones': {
    x: 0,
    y: 0,
    scale: 1,
  },
  'main_bg_all': {
    x: 0,
    y: 0,
    scale: 1,
  },
  'main_castle': {
    x: 0,
    y: 0,
    scale: 1,
  },
  'main_main_trees_mountains': {
    x: 0,
    y: 0,
    scale: 1,
  },
  'mountains': {
    x: 0,
    y: 0,
    scale: 1,
  },
  'sefs_bg_fire': {
    x: 0,
    y: 0,
    scale: 1,
  },
  'fs_reel': {
    x: 0,
    y: 30,
    scale: 1,
  },
  'main_rame': {
    x: -2,
    y: 10,
    scale: 1,
  },
  'main_rame_back': {
    x: 0,
    y: 0,
    scale: 1,
  },
  'fs_reel_back': {
    x: 0,
    y: 0,
    scale: 1,
  },
}
